// extracted by mini-css-extract-plugin
export var body = "_3b-1";
export var bodyPadded = "_3b-2";
export var chevron = "_3b-4";
export var chevronOpen = "_3b-5";
export var header = "_3b-0";
export var icon = "_3b-3";